import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Alert } from "@blueprintjs/core";

import { Code } from "@components";

import { WorkbenchContext } from "@pages/editor/providers";

const ConfirmDelete = () => {
  const { workbench } = useContext(WorkbenchContext);

  const deleteAndClose = () => {
    workbench.ui.fileToDelete?.delete();
    workbench.ui.closeConfirmDeleteAlert();
  };

  return (
    <Alert
      isOpen={workbench.ui.isConfirmDeleteAlertOpen}
      confirmButtonText={"Delete"}
      cancelButtonText={"Cancel"}
      onCancel={workbench.ui.closeConfirmDeleteAlert}
      onConfirm={deleteAndClose}
      intent="danger"
      icon={"trash"}
    >
      Are you sure you want to delete{" "}
      <Code inline light>
        {workbench.ui.fileToDelete?.snippet.name}
      </Code>
      ?
    </Alert>
  );
};

export const ConfirmDeleteAlert = observer(ConfirmDelete);
